<template>
  <v-container>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>{{ $t('COMPARATIVE INVOICES') }}</v-toolbar-title>
      <v-spacer />
      <v-icon @click="$router.go(-1)">
        mdi-arrow-collapse-left
      </v-icon>
    </v-toolbar>
    <div v-for="actualInvoice of invoices" :key="actualInvoice.invoice.id">
      <v-card elevation="12" style="margin-top: 10px">
        <v-card-title class="justify-center" style="text-align: center">
          {{ $t('INVOICE NUMBER ') }} {{ actualInvoice.invoice.number }}
        </v-card-title>
        <v-card-text v-if="actualInvoice" :id="'capture' + actualInvoice.image.IdInvoice" align="center" style="display: inline-table">
          <img v-if="actualInvoice.image.originalName.split('.').pop().toLowerCase() !== 'pdf'" ref="invoiceImage" :style="{width: widthImage}" :src="'/api/uploads/' + actualInvoice.image.originalName" @load="download()">
          <pdf v-if="actualInvoice.image.originalName.split('.').pop().toLowerCase() === 'pdf'" ref="previewImg" :style="{height: heightPDFcalc, width: widthPDFcalc}" :src="'/api/uploads/' + actualInvoice.image.originalName" />
          <v-container id="Captura">
            <v-row justify="center">
              <div class="centered">
                <div v-if="newPayer(actualInvoice)">
                  {{ $t('New Payer: ') + actualInvoice.invoice.payerCif }}
                </div>
                <div v-if="newReceiver(actualInvoice)">
                  {{ $t('New Receiver: ') + actualInvoice.invoice.receiverCif }}
                </div>
                <div v-if="newAmount(actualInvoice)">
                  {{ $t('New Amount: ') + actualInvoice.invoice.amount + ' €' }}
                </div>
              </div>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center" style="margin-bottom: 10px">
            <v-btn color="primary" @click="screenshot(actualInvoice)">
              <v-icon style="margin-right: 5px">
                mdi-arrow-down-bold-hexagon-outline
              </v-icon>{{ $t('Download') }}
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import html2canvas from 'html2canvas';
import pdf from 'vue-pdf';

export default {
    name: "ComparativeInvoice",
    components: {
        pdf
    },
    data () {
        return {
            invoices: [],
            originalInvA: null,
            originalInvB: null,
            hideResultCapture: false,
            pdf: false,
            heightPDF: 350,
            widthImage: '100%'
        };
    },
    computed: {
        heightPDFcalc: function () {
            return this.heightPDF + 'px';
        },
        widthPDFcalc: function () {
            return this.heightPDF * 0.7 + 'px';
        },
    },
    created () {
        if (this.$route.params.download) {
            this.widthImage = 'uset';
        } else {
            this.fetch();
        }
    },
    methods: {
        fetch () {
            ApiRepository.creatingResultInvoicesOld(this.$route.params.id)
                .then((res) => {
                    if (res.data) {
                        this.invoices.push(res.data.invoiceA);
                        this.invoices.push(res.data.invoiceB);
                        this.originalInvA = res.data.invoiceAO;
                        this.originalInvB = res.data.invoiceBO;
                        this.invoices = this.invoices.filter(this.imParticipant);
                        this.showModal = true;
                    }
                })
                .catch((err) => {
                    console.log("ERROR: " + err);
                })
                .finally(() => {
                    this.$root.$emit('stop-loading');
                });
        },
        imParticipant (value) {
            return this.$user.cif === value.invoice.payerCif || this.$user.cif === value.invoice.receiverCif;
        },
        newPayer (inv) {
            if (this.originalInvA.number === inv.invoice.number) return this.originalInvA.payerCif !== inv.invoice.payerCif;
            else return this.originalInvB.payerCif !== inv.invoice.payerCif;
        },
        newReceiver (inv) {
            if (this.originalInvA.number === inv.invoice.number) return this.originalInvA.receiverCif !== inv.invoice.receiverCif;
            else return this.originalInvB.receiverCif !== inv.invoice.receiverCif;
        },
        newAmount (inv) {
            if (this.originalInvA.number === inv.invoice.number) return this.originalInvA.amount !== inv.invoice.amount;
            else return this.originalInvB.amount !== inv.invoice.amount;
        },
        download () {
            if (this.$route.params.download) {
                const sel = "#capture" + this.$route.params.id;
                this.downloading = true;
                html2canvas(document.querySelector(sel), {scale: 3}).then(canvas => {
                    const a = document.createElement("a");
                    a.setAttribute('href', canvas.toDataURL('image/png'));
                    a.setAttribute('download', 'Test.png');
                    a.click();
                });
            }
        },
        screenshot (actualInvoice) {
            console.log(actualInvoice.image.IdInvoice);
            this.$router.push({name: 'ComparativeInvoiceDownload', params: {id: this.$route.params.id, idInvoice: actualInvoice.image.IdInvoice}, replace: true}).catch((e) => { console.log(e); });
            /*const sel = "#capture" + actualInvoice.invoice._id;
            console.log(sel);
            this.downloading = true;
            html2canvas(document.querySelector(sel), {scale: 3}).then(canvas => {
                const a = document.createElement("a");
                a.setAttribute('href', canvas.toDataURL('image/png'));
                a.setAttribute('download', 'Test.png');
                a.click();
            });*/
        }
    }
};
</script>

<style scoped>
  .centered {
    border: #FF6961 2px solid;
    color: #FF6961;
    padding: 8px;
    position: absolute;
    font-weight: bold;
    top: 45%;
    font-size: 15px;
    -webkit-transform: rotate(25deg);
  }
</style>
